import React from "react";
import { DividerOrientation, LineStyle } from "./styles";

interface DividerProps extends React.HTMLAttributes<HTMLHRElement> {
  orientation?: DividerOrientation;
  thickness?: number;
  length?: number;
}

const Divider = ({
  orientation = "horizontal",
  thickness,
  length,
  ...rest
}: DividerProps) => {
  return (
    <LineStyle
      {...rest}
      orientation={orientation}
      thickness={thickness}
      length={length}
    />
  );
};

export default Divider;
